<template>
  <v-list two-line>
    <v-list-tile>
      <v-list-tile-content>
        <v-list-tile-title><strong>Status</strong></v-list-tile-title>
        <v-list-tile-content>
          <status-label :status="ticket.status"></status-label>
        </v-list-tile-content>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="ticket.user">
      <v-list-tile-content>
        <v-list-tile-title><strong>Aluno</strong></v-list-tile-title>
        <v-list-tile-content>
          {{ ticket.user.name }}
        </v-list-tile-content>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile>
      <v-list-tile-content>
        <v-list-tile-title><strong>Assunto</strong></v-list-tile-title>
        <v-list-tile-content>
          {{ ticket.subject }}
        </v-list-tile-content>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile>
      <v-list-tile-content>
        <v-list-tile-title><strong>Data de abertura</strong></v-list-tile-title>
        <v-list-tile-content>
          {{ ticket.created_at | moment('LLL') }}
        </v-list-tile-content>
      </v-list-tile-content>
    </v-list-tile>

    <v-btn @click.stop="resolve()" round depressed color="success"
      v-if="ticket.status && ticket.status == 'open'"
      :loading="loadingRequest">
      <v-icon small left>fal fa-check</v-icon>
      Marcar como resolvido
    </v-btn>

    <v-btn @click.stop="deleteItem()" round depressed color="error"
      v-if="ticket.status && ticket.status == 'closed'"
      :loading="loadingRequest">
      <v-icon small left>fal fa-trash-alt</v-icon>
      Apagar ticket
    </v-btn>
  </v-list>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
import router from '@/router'
import AdminTicketStatusLabel from '@/components/admin/support/AdminTicketStatusLabel'

export default {
  props: ['ticket'],

  data: () => ({
    loadingRequest: false
  }),

  methods: {
    resolve () {
      this.loadingRequest = true
      this.ticket.status = 'closed'

      // eslint-disable-next-line
      axios.put(`${API.userTickets}/${this.$route.params.id}`, this.ticket).then(response => {
        this.loadingRequest = false
        EventBus.$emit('loadTicket')
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao fechar o ticket',
          color: 'error'
        })
      })
    },

    deleteItem (confirmUnRequired) {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      const path = `${API.userTickets}/${this.$route.params.id}`

      if (!confirmUnRequired) {
        confirm(`Tem certeza que deseja apagar o ticket?`) && this.deleteItem(true)
        return
      }

      axios.delete(path).then(response => {
        router.push('/support')
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro apagar o item', color: 'error' })
        EventBus.$emit('appLoading', false)
      })
    }
  },

  components: {
    'status-label': AdminTicketStatusLabel
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/support/AdminTicketShowSidebar.vue